import { CaretRight } from '@phosphor-icons/react';
import classnames from 'classnames';
import type { CSSProperties } from 'react';
import { breadcrumbs } from './Breadcrumbs.css';
import type { BreadcrumbsElementProps } from './Breadcrumbs.types';

export function BreadcrumbsElement(props: BreadcrumbsElementProps) {
  const { element, attributes } = props;

  const { data, color, fontFamily } = element.attrs || {};

  return (
    <div
      style={{ '--breadcrumbs-color': color, '--breadcrumbs-font-family': fontFamily } as CSSProperties}
      className={classnames('relative w-fit my-4', breadcrumbs)}
      {...attributes}
    >
      <ul className="flex flex-wrap items-center gap-2 text-xs font-semibold">
        {data?.breadcrumbs.map((item, index) => (
          <li
            key={`${item.text}-${index}`}
            className={classnames('flex items-center gap-2', {
              'flex-shrink-0': index !== data.breadcrumbs.length - 1,
              'flex-shrink min-w-0 flex-1': index === data.breadcrumbs.length - 1,
            })}
            style={{ color: color }}
          >
            {index === data.breadcrumbs.length - 1 ? (
              <span className="truncate">{item.text}</span>
            ) : item.href ? (
              <a className="truncate" href={item.href}>
                {item.text}
              </a>
            ) : (
              <span className="truncate">{item?.text}</span>
            )}
            {index !== data.breadcrumbs.length - 1 && <CaretRight size={14} />}
          </li>
        ))}
      </ul>
    </div>
  );
}
